import reportApi from '@/api/reports/reporting-api'

export default {
  namespaced: true,
  state: {},
  mutations: {},
  actions: {
    async fetch() {
      try {
        const response = await reportApi.fetch();
        return Promise.resolve(response.data);
      } catch (error) {
        return await Promise.reject(error);
      }
    },
    async fetchById(_, {id}) {
      try {
        const response = await reportApi.fetchById(id);
        return Promise.resolve(response.data);
      } catch (error) {
        return await Promise.reject(error);
      }
    },
    async fetchMetadataById(_, {id}) {
      try {
        const response = await reportApi.fetchMetadata(id);
        return Promise.resolve(response.data);
      } catch (error) {
        return await Promise.reject(error);
      }
    },
    async fetchMenuOptions() {
      try {
        const response = await reportApi.fetchMenuOptions();
        return Promise.resolve(response.data);
      } catch (error) {
        return await Promise.reject(error);
      }
    },
    async fetchLinks() {
      try {
        const response = await reportApi.fetchLinks();
        return Promise.resolve(response.data);
      } catch (error) {
        return await Promise.reject(error);
      }
    },
    async fetchMenuPositions(_, {id}) {
      try {
        const response = await reportApi.fetchMenuPositions(id);
        return Promise.resolve(response.data);
      } catch (error) {
        return await Promise.reject(error);
      }
    },
    async upsertMetadata({dispatch}, form) {
      try {
        const response = await reportApi.upsertMetadata(form);
        dispatch('NOTIFY_MSG', 'reporting.metadata.notification.save',
          {root: true});
        return Promise.resolve(response.data);
      } catch (error) {
        await dispatch('NOTIFY_ERROR', error, {root: true});
        return await Promise.reject(error);
      }
    },
    async upsertMenuPositions({dispatch}, {id, positions}) {
      try {
        const response = await reportApi.upsertMenuPositions(id, positions);
        dispatch('NOTIFY_MSG', 'reporting.menuPosition.notification.save',
          {root: true});
        return Promise.resolve(response.data);
      } catch (error) {
        await dispatch('NOTIFY_ERROR', error, {root: true});
        return await Promise.reject(error);
      }
    },
    async saveForPreview({dispatch}, {id, items, silent}) {
      try {
        await reportApi.saveForPreview(id, items);

        if(!silent)
          dispatch('NOTIFY_MSG', 'reporting.notification.save',
            {root: true});

        return Promise.resolve();
      } catch (error) {
        await dispatch('NOTIFY_ERROR', error, {root: true});
        return await Promise.reject(error);
      }
    },
    async prepareForExport({dispatch}, data) {
      try {
        const response = await reportApi.prepareForExport(data);
        return Promise.resolve(response.data);
      } catch (error) {
        await dispatch('NOTIFY_ERROR', error, {root: true});
        return await Promise.reject(error);
      }
    },
    async multiPrepareForExport({dispatch}, data) {
      try {
        const response = await reportApi.multiPrepareForExport(data);
        return Promise.resolve(response.data);
      } catch (error) {
        await dispatch('NOTIFY_ERROR', error, {root: true});
        return await Promise.reject(error);
      }
    },
    async printReport({dispatch}, {reportId, data, merge}) {
      if (merge === undefined || merge === null) merge = '00000000-0000-0000-0000-000000000000';

      const config = await dispatch('config/fetch', {}, {root: true});
      dispatch('reporting/prepareForExport', {
        reportId: reportId,
        data,
        merge
      }, {root: true}).then(requestId => {
        window.open(`${config.reportDesignerUrl}/designer/PrintPdf/${requestId}`);
      });
    },
    async printReports({dispatch}, data) {
      const config = await dispatch('config/fetch', {}, {root: true});
      for (let item of data) {
        dispatch('reporting/prepareForExport', {
          reportId: item.reportId,
          data:  item.data,
          merge: item.merge
        }, {root: true}).then(requestId => {
          window.open(`${config.reportDesignerUrl}/designer/PrintPdf/${requestId}`);
        });
      }

    },
    async multiPrintReport({dispatch}, data) {
      const config = await dispatch('config/fetch', {}, {root: true});
      dispatch('reporting/multiPrepareForExport', data, {root: true}).then(requestIds => {
        const reportQueryString = requestIds.join(';');
        window.open(`${config.reportDesignerUrl}/designer/MultiPrintPdf?id=${reportQueryString}`);
      });
    }
  }
}
